<template>
  <div class="container-fluid pt-5">
    <div class="row">
      <div class="col-md-5 mx-auto">
        <upload-file-form @uploadSuccess="onUploadSuccess"></upload-file-form>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col">
        <div class="card">
          <h3 class="card-header">Latest actions</h3>
          <uploads-table :uploads="uploads"></uploads-table>
        </div>
      </div>
    </div>

    <b-modal
      v-model="showModal"
      title="Successful Upload"
      header-bg-variant="success"
      header-text-variant="light">
      <div slot="modal-header-close"></div>
      <p>The file was uploaded successfully.</p>
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" class="float-right" variant="primary" @click="showModal=false">OK</b-btn>
      </div>
    </b-modal>

  </div>
</template>


<script>
import UploadFileForm from '../components/forms/UploadFileForm'
import UploadsTable from '../components/tables/UploadsTable'

export default {
  components: {
    UploadFileForm,
    UploadsTable,
  },
  created() {
    this.loadRecentUploads()
  },
  data() {
    return {
      showModal: false,
      timeoutID: null,
    }
  },
  computed: {
    uploads() {
      return this.$store.getters.getRecentUploadsSummary
    },
  },
  methods: {
    onUploadSuccess() {
      this.showModal = true
      this.loadRecentUploads()
    },
    loadRecentUploads() {
      var self = this
      this.$store.dispatch('loadRecentUploadsSummary')
        .then(uploads => {
          window.clearTimeout(self.timeoutID)
          const hasUnprocessedFile = uploads.find(upload => upload.status === 'pending' || upload.status === 'working')
          if (hasUnprocessedFile) {
            self.timeoutID = window.setTimeout(self.loadRecentUploads, 1000)
          }
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/-service-app/pages/HomePage.vue